import { Container, Heading, Spinner } from '@treams/treams-ui';
import { t } from 'i18next';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

const StyledSubgoalsContainer = styled(Container)`
	background: ${(props) => props.theme.colors.whiteBlue};
`;

export default function SubgoalsContainer({
	children,
	loading,
}: {
	children: React.ReactNode;
	loading?: boolean;
}) {
	return (
		<StyledSubgoalsContainer py={4}>
			<Heading mb={3}>
				<Flex alignItems="center">
					<Box>{t('subgoals.list.title')}</Box>
					{loading && <Spinner ml={2} />}
				</Flex>
			</Heading>
			{children}
		</StyledSubgoalsContainer>
	);
}
